import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

// import { messaging , requestNotificationPermission } from '../../helper/firebase';


const SellerNotifications = () => {
  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  // Function to fetch notifications
  const fetchNotifications = () => {
    axios
      .get("getnotificationbytenant")
      .then((response) => {
        setNotifications(response.data.notifications);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching notifications:", error);
        setLoading(false);
      });
  };

  // Fetch notifications every 10 seconds
  useEffect(() => {
    fetchNotifications(); // Initial fetch

    const intervalId = setInterval(() => {
      fetchNotifications();
    }, 30000); // 30000 ms = 30 seconds

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  const markAsRead = (notificationId) => {
    axios
      .post("markasread/", { notificationId })
      .then(() => {
        setNotifications((prevNotifications) =>
          prevNotifications.filter((notification) => notification._id !== notificationId)
        );
      })
      .catch((error) => {
        console.error("Error marking notification as read:", error);
      });
  };

  if (loading) {
    return <p>Loading notifications...</p>;
  }

  return (
    <div className="notifications-container">
  {notifications.length > 0 ? (
    notifications.map((notification) => (
      <div key={notification._id} className="notification-bar">
        <div className="notification-content">
          <span className="icon">
            <img src="assets/img/icons/cart.svg" alt="" style={{ marginBottom: "-4px" }} />
          </span>
          <span className="message">
            {notification.count}{" "}
            {notification.count > 0 && notification?.type === "new-order" && (
              t?.[l]?.["new_orders"] || "New Orders Placed!"
            )}
            {notification.count > 0 && notification?.type === "request_refund" && (
              t?.[l]?.["refund_request"] || "Refund Request!"
            )}
          </span>
        </div>
        <div className="notification-actions">
          {notification.count > 0 && notification?.type === "new-order" && (
            <Link to="orders">
              <span className="dismiss">
                {t?.[l]?.["view_order"] || "View Order"}
              </span>
            </Link>
          )}
          {notification.count > 0 && notification?.type === "request_refund" && (
            <Link to="refunds">
              <span className="dismiss">
                {t?.[l]?.["view_refunds"] || "View Refunds"}
              </span>
            </Link>
          )}
          <span className="dismiss" onClick={() => markAsRead(notification._id)}>
            {t?.[l]?.["dismiss"] || "Dismiss"}
          </span>
        </div>
      </div>
    ))
  ) : (
    <div className="notification-bar no-notification">
      <div>{t?.[l]?.["no_new_notifications"] || "No new notifications"}</div>
    </div>
  )}
</div>

  );
};

export default SellerNotifications;

// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useSelector } from "react-redux";
// import { Link } from "react-router-dom";

// // import { messaging , requestNotificationPermission } from '../../helper/firebase';


// const SellerNotifications = () => {
//   const l = useSelector((state) => state.language || "en");
//   const t = useSelector((state) => state.translation || "en");
//   const [notifications, setNotifications] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // Function to fetch notifications
//   const fetchNotifications = () => {
//     axios
//       .get("getnotificationbytenant")
//       .then((response) => {
//         setNotifications(response.data.notifications);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error("Error fetching notifications:", error);
//         setLoading(false);
//       });
//   };

//   // Fetch notifications every 10 seconds
//   useEffect(() => {
//     fetchNotifications(); // Initial fetch

//     const intervalId = setInterval(() => {
//       fetchNotifications();
//     }, 30000); // 30000 ms = 30 seconds

//     // Cleanup the interval on component unmount
//     return () => clearInterval(intervalId);
//   }, []);

//   const markAsRead = (notificationId) => {
//     axios
//       .post("markasread/", { notificationId })
//       .then(() => {
//         setNotifications((prevNotifications) =>
//           prevNotifications.filter((notification) => notification._id !== notificationId)
//         );
//       })
//       .catch((error) => {
//         console.error("Error marking notification as read:", error);
//       });
//   };

//   if (loading) {
//     return <p>Loading notifications...</p>;
//   }

//   return (
//     <div className="notifications-container">
//       {notifications.length > 0 ? (
//         notifications.map((notification) => (
//           <div key={notification._id} className="notification-bar">
//             <div className="notification-content">
//               <span className="icon">
//                 <img src="assets/img/icons/cart.svg" alt="" style={{ marginBottom: "-4px" }} />
//               </span>
//               <span className="message">
//                  {notification.count}{" "} 
//                 {notification.count > 0 && notification?.type === "new-order" && (
//                   t?.[l]?.["new_orders"] || "New Orders Placed!"
//                 )}
//                 {notification.count > 0 && notification?.type === "request_refund" && (
//                   t?.[l]?.["refund_request"] || "Refund Request!"
//                 )}

//               </span>
//             </div>
//             <div className="notification-actions">
//             {notification.count > 0 && notification?.type === "new-order" && (
//               <Link to="orders">
//                 <span className="dismiss">
//                   {t?.[l]?.["view_order"] || "View Order"}
//                 </span>
//               </Link>
//               )}
//               {notification.count > 0 && notification?.type === "request_refund" && (
//                 <Link to="refunds">
//                 <span className="dismiss">
//                   {t?.[l]?.["view_refunds"] || "View Refunds"}
//                 </span>
//               </Link>

// )}
//               <span
//                 className="dismiss"
//                 onClick={() => markAsRead(notification._id)}
//               >
//                 {t?.[l]?.["dismiss"] || "Dismiss"}
//               </span>
//             </div>
//           </div>
//         ))
//       ) : (
//         <div className="notification-bar no-notification">
//           <div>{t?.[l]?.["no_new_notifications"] || "No new notifications"}</div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SellerNotifications;
